export const expiryPeriodOptions = [
    { value: 0, label: 'at Billing Period End' },
    { value: 1, label: 'in 1 Billing Period' },
    { value: 2, label: 'in 2 Billing Periods' },
    { value: 3, label: 'in 3 Billing Periods' },
    { value: 4, label: 'in 4 Billing Periods' },
    { value: 5, label: 'in 5 Billing Periods' },
    { value: 6, label: 'in 6 Billing Periods' },
    { value: 7, label: 'in 7 Billing Periods' },
    { value: 8, label: 'in 8 Billing Periods' },
    { value: 9, label: 'in 9 Billing Periods' },
    { value: 10, label: 'in 10 Billing Periods' },
    { value: 11, label: 'in 11 Billing Periods' },
    { value: 12, label: 'in 12 Billing Periods' }
  ];